import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const Edit = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [inputs, setInputs] = useState({ mushok_6_4_show: true });
  const [unit, setUnit] = useState([]);
  const [unitSupply, setUnitSupply] = useState([]);
  const [category, setCategory] = useState([]);
  const [error, setError] = useState({});
  const [showAccountsForm, setShowAccountsForm] = useState(false);
  const [allowConversion, setAllowConversion] = useState(false);
  const [kitchen, setKitchen] = useState([]);

  const [selectedUnitOption, setSelectedUnitOption] = useState(null);
  const [selectedUnitSupplyOption, setSelectedUnitSupplyOption] = useState(null);
  const [selectProductCatOption, setSelectProductCatOption] = useState(null);
  const [selectKitchenOption, setSelectKitchenOption] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);

    try {
      const unitData = await Http.get("/active-unit");
      const kitchenData = await Http.get("/kitchen-staff");
      const categoryData = await Http.get("/product-active");
      const productRes = await Http.get("/product/" + id + "/edit");
      setUnit(unitData.data);
      setUnitSupply(unitData.data);
      setCategory(categoryData.data);
      setKitchen(kitchenData.data);
      console.log(productRes.data);
      
      // Set allowConversion if type is finished_goods
      if (productRes.data.type === "finished_goods") {
        setAllowConversion(true);
      }
      
      setInputs({
        code: productRes.data.code,
        name: productRes.data.name,
        unit_id: productRes.data.unit_id,
        price: productRes.data.price,
        sku: productRes.data.sku,
        pack_size: productRes.data.pack_size,
        stock: productRes.data.stock,
        type: productRes.data.type,
        category_id: productRes.data.category_id,
        kitchen_id: productRes.data.kitchen_id,
        notes: productRes.data.notes,
        vat: productRes.data.vat,
        status: productRes.data.status,
        std_price_accounts: productRes.data.std_price_accounts,
        vat_value_accounts: productRes.data.vat_value_accounts,
        sdv_inv: productRes.data.sdv_inv,
        sd_inv: productRes.data.sd_inv,
        vat_inv: productRes.data.vat_inv,
        unit_supply: productRes.data.unit_supply,
        unit_supply_qty: productRes.data.unit_supply_qty,
        mushok_6_4_show: productRes.data.mushok_6_4_show,
        // Load conversion data if exists
        ac: productRes.data.conversion?.ac || "",
        non_ac: productRes.data.conversion?.non_ac || "",
        staff: productRes.data.conversion?.staff || "",
        others: productRes.data.conversion?.others || "",
      });

      setSelectedUnitOption({
        label: productRes.data.unit.name,
        value: productRes.data.unit.id,
      });

      // setSelectedUnitSupplyOption({
      //   label: productRes.data.unit_supply_id.name,
      //   value: productRes.data.unit_supply_id.id,
      // });

      setSelectProductCatOption({
        label: productRes.data.category.name,
        value: productRes.data.category.id,
      });
      setSelectKitchenOption({
        label: productRes.data.kitchen.name,
        value: productRes.data.kitchen.id,
      });

      const unitRes = await Http.get("/unitSelect2");
      setUnit(unitRes.data);

      const categoryRes = await Http.get("/productCatSelect2");
      setCategory(categoryRes.data);

      const unitSupplyRes = await Http.get("/unitSelect2");
      setUnitSupply(unitSupplyRes.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const fetchData = () => {
  //   Http.get("/product/" + id + "/edit").then((res) => {
  //     console.log(res.data);
  //     setInputs({
  //       code: res.data.code,
  //       name: res.data.name,
  //       unit_id: res.data.unit_id,
  //       price: res.data.price,
  //       sku: res.data.sku,
  //       pack_size: res.data.pack_size,
  //       stock: res.data.stock,
  //       type: res.data.type,
  //       category_id: res.data.category_id,
  //       notes: res.data.notes,
  //       vat: res.data.vat,
  //       status: res.data.status,
  //       std_price_accounts: res.data.std_price_accounts,
  //       vat_value_accounts: res.data.vat_value_accounts,
  //       sdv_inv: res.data.sdv_inv,
  //       sd_inv: res.data.sd_inv,
  //       vat_inv: res.data.vat_inv,
  //       unit_supply: res.data.unit_supply,
  //       unit_supply_qty: res.data.unit_supply_qty,
  //       mushok_6_4_show: res.data.mushok_6_4_show,
  //     });

  //     setSelectedUnitOption({
  //       label: res.data.unit.name,
  //       value: res.data.unit.id,
  //     });

  //     setSelectedUnitSupplyOption({
  //       label: res.data.unit_supply_id.name,
  //       value: res.data.unit_supply_id.id,
  //     });

  //     setSelectProductCatOption({
  //       label: res.data.category.name,
  //       value: res.data.category.id,
  //     });
  //   });

  //   Http.get("/unitSelect2").then((res) => {
  //     setUnit(res.data);
  //   });

  //   Http.get("/productCatSelect2").then((res) => {
  //     setCategory(res.data);
  //   });

  //   Http.get("/unitSelect2").then((res) => {
  //     setUnitSupply(res.data);
  //   });
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  useEffect(() => {
    if (inputs.type === "finished_goods") {
      setShowAccountsForm(true);
    } else {
      setShowAccountsForm(false);
    }
  }, [inputs.type]);

  const selectHandleChange = (selectedOption, actionMeta) => {
    if (actionMeta.name === "unit_id") {
      setSelectedUnitOption({
        label: selectedOption.label,
        value: selectedOption.value,
      });
    }

    if (actionMeta.name === "category_id") {
      setSelectProductCatOption({
        label: selectedOption.label,
        value: selectedOption.value,
      });
    }
    if (actionMeta.name === "kitchen_id") {
      setSelectKitchenOption({
        label: selectedOption.label,
        value: selectedOption.value,
      });
    }

    if (actionMeta.name === "unit_supply") {
      setSelectedUnitSupplyOption({
        label: selectedOption.label,
        value: selectedOption.value,
      });
    }

    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    
    setInputs((values) => {
      let updatedInputs = { ...values, [name]: value };
      
      if (name === "type") {
        updatedInputs = {
          ...updatedInputs,
          ac: "",
          non_ac: "",
          staff: "",
          others: ""
        };
        
        if (value === "finished_goods") {
          setAllowConversion(true);
        } else {
          setAllowConversion(false);
        }
      }
      
      return updatedInputs;
    });
  };

  const validateFinishedGoods = () => {
    if (inputs.type === "finished_goods") {
      let errors = {};

      if (!inputs.ac) errors.ac = "AC is required";
      if (!inputs.non_ac) errors.non_ac = "Non AC is required";
      if (!inputs.staff) errors.staff = "Staff is required";
      if (!inputs.others) errors.others = "Others is required";

      if (Object.keys(errors).length > 0) {
        setError(errors);
        return false;
      }
    }
    return true;
  };

  const formSubmit = () => {
    if (!validateFinishedGoods()) return;
    
    console.log(inputs);
    Http.put("/product/" + id, inputs)
      .then((res) => {
        // If finished goods, also update conversion data
        if (inputs.type === "finished_goods") {
          const conversionData = {
            product_id: id,
            ac: inputs.ac || 0,
            non_ac: inputs.non_ac || 0,
            staff: inputs.staff || 0,
            others: inputs.others || 0,
          };

          Http.post("/product-conversion", conversionData)
            .catch((e) => {
              console.error("Conversion save error:", e);
            })
            .finally(() => {
              navigate("/product", {
                state: { message: res.data.message, type: res.data.type },
              });
            });
        } else {
          navigate("/product", {
            state: { message: res.data.message, type: res.data.type },
          });
        }
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Product Form</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Edit Product Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>


                <div className="row">
                  <div className="col-lg">
                    <label>
                      Code <i className="fa fa-star required"></i>
                    </label>
                    <input type="text" className="form-control" name="code" value={inputs.code || ""} onChange={handleChange} />
                  </div>
                  <div className="col-lg">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input type="text" className="form-control" name="name" value={inputs.name || ""} onChange={handleChange} />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Unit <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectedUnitOption}
                      value={selectedUnitOption}
                      onChange={selectHandleChange}
                      name="unit_id"
                      options={unit}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Price <i className="fa fa-star required"></i>
                    </label>
                    <input type="text" className="form-control" name="price" value={inputs.price || ""} onChange={handleChange} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      SKU
                      {/* <i className="fa fa-star required"></i> */}
                    </label>
                    <input type="text" className="form-control" name="sku" value={inputs.sku || ""} onChange={handleChange} />
                  </div>
                  <div className="col-lg">
                    <label>Pack Size</label>
                    <input type="text" className="form-control" name="pack_size" value={inputs.pack_size || ""} onChange={handleChange} />
                  </div>
                  <div className="col-lg">
                    <label>Stock</label>
                    <input type="text" className="form-control" name="stock" value={inputs.stock || ""} onChange={handleChange} readOnly />
                  </div>
                  <div className="col-lg">
                    <label>
                      Type <i className="fa fa-star required"></i>
                    </label>
                    <select className="form-control" name="type" onChange={handleChange}>
                      <option value="">Select Type</option>
                      <option value="raw_materials" selected={inputs.type === "raw_materials" ? true : false}>
                        Raw Materials
                      </option>
                      <option value="packing_materials" selected={inputs.type === "packing_materials" ? true : false}>
                        Packing Materials
                      </option>
                      <option value="finished_goods" selected={inputs.type === "finished_goods" ? true : false}>
                        Finished Goods
                      </option>
                    </select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label htmlFor="">
                      Category <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectProductCatOption}
                      value={selectProductCatOption}
                      onChange={selectHandleChange}
                      name="category_id"
                      options={category}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Kitchen  <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectKitchenOption}
                      value={selectKitchenOption}
                      onChange={selectHandleChange}
                      name="kitchen_id"
                      options={kitchen}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Vat</label>
                    <input type="text" className="form-control" name="vat" value={inputs.vat || ""} onChange={handleChange} />
                  </div>
                  <div className="col-lg">
                    <label>Notes</label>
                    <textarea className="form-control" name="notes" value={inputs.notes || ""} onChange={handleChange} placeholder="Notes" />
                  </div>
                  <div className="col-lg">
                    <label>Status</label>
                    <select className="form-control" name="status" onChange={handleChange}>
                      <option value="">Select Status</option>
                      <option value="active" selected={inputs.status === "active" ? true : false}>
                        Active
                      </option>
                      <option value="inactive" selected={inputs.status === "inactive" ? true : false}>
                        Inactive
                      </option>
                    </select>
                  </div>
                </div>

                {allowConversion && (
                  <div className="row mt-3">
                    <div className="col-12">
                      <h6 className="card-body-title mg-sm-b-30">Conversion Details (Required for Finished Goods)</h6>
                    </div>
                    <div className="col-lg">
                      <label>
                        AC <i className="fa fa-star required"></i>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="ac"
                        value={inputs.ac || ""}
                        onChange={handleChange}
                        placeholder="Enter AC conversion factor"
                      />
                    </div>
                    <div className="col-lg">
                      <label>Non AC <i className="fa fa-star required"></i></label>
                      <input
                        type="text"
                        className="form-control"
                        name="non_ac"
                        value={inputs.non_ac || ""}
                        onChange={handleChange}
                        placeholder="Enter Non AC conversion factor"
                      />
                    </div>
                    <div className="col-lg">
                      <label>Staff <i className="fa fa-star required"></i></label>
                      <input
                        type="text"
                        className="form-control"
                        name="staff"
                        value={inputs.staff || ""}
                        onChange={handleChange}
                        placeholder="Enter Staff conversion factor"
                      />
                    </div>
                    <div className="col-lg">
                      <label>Others <i className="fa fa-star required"></i></label>
                      <input
                        type="text"
                        className="form-control"
                        name="others"
                        value={inputs.others || ""}
                        onChange={handleChange}
                        placeholder="Enter Others conversion factor"
                      />
                    </div>
                  </div>
                )}


                <div className="row mt-3">
                  <div className="col-3">
                    <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>)}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
